export default __webpack_public_path__ + "static/media/dummyData.847c2e7c.jpeg";